import React, { FC } from 'react';
import { UncontrolledPopover, PopoverBody, PopoverHeader } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import acceptIcon from 'style/imgs/icons/accept.svg';
import rejectIcon from 'style/imgs/icons/reject.svg';
import styles from 'pages/signUp/index.module.scss';

interface IPasswordProps {
  password: string;
  target: string;
}
const PswPopOver: FC<IPasswordProps> = ({ password, target }) => {
  const accept = <img src={acceptIcon} alt="accept" />;
  const reject = <img src={rejectIcon} alt="reject" />;

  return (
    <UncontrolledPopover trigger="focus" placement="top" target={target}>
      <PopoverHeader>Your password must have:</PopoverHeader>
      <PopoverBody className={styles.popover}>
        <li className={styles.li}>
          {' '}
          {/.{8,64}/.test(password) ? accept : reject} 8-64 Characters
        </li>
        <li className={styles.li}>
          {' '}
          {/[A-Z|А-Я|Ё]+/.test(password) || /\d+/.test(password)
            ? accept
            : reject}{' '}
          Numbers or UPPER case letter
        </li>
        <li className={styles.li}>
          {' '}
          {/[a-z|а-я|ё]+/.test(password) ? accept : reject}
          Lower case letter
        </li>
      </PopoverBody>
    </UncontrolledPopover>
  );
};

export default PswPopOver;
